import { render, staticRenderFns } from "./TeamViewHeader.vue?vue&type=template&id=3e4263d1&"
import script from "./TeamViewHeader.vue?vue&type=script&lang=js&"
export * from "./TeamViewHeader.vue?vue&type=script&lang=js&"
import style0 from "./TeamViewHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports